import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16465d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[red]"
}

import { INPUT_TYPE } from "@/utils/constants";
import { computed, ref } from "vue";
import DatePickInput from "../common/datePickInput.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'datePicker',
  props: {
  disabled: { type: Boolean, required: false },
  title: { type: String, required: true },
  index: { type: Number, required: false, default: 0 },
  type: { type: String, required: false, default: "text" },
  placeholder: { type: String, required: true },
  required: { type: Boolean, required: false, default: false },
  classTitle: { type: String, required: false, default: "" },
  colClass: { type: String, required: false, default: "" },
  validState: {
    type: Boolean as PropType<boolean | null>,
    required: false,
    default: null,
  },
  modelValue: {
    type: [String, Number],
    default: () => {
      return null;
    },
  },
  dataCyId: { type: String, required: false, default: "" },
  validMessage: { type: String, required: false, default: "" },
  delayChangeInput: { type: Number, default: 0, required: false },
  validation: { type: Object, required: false, default: null },
  isAutoFocus: { type: Boolean, required: false, default: false },
  inputClass: { type: String, required: false, default: "" },
  validationClass: { type: String, required: false, default: "" },
  colTitle: { type: Number, required: false, default: 5 },
  colInput: { type: Number, required: false, default: 7 },
},
  emits: [
  "update:modelValue",
  "update:valueTeamPage",
  "handleBlur",
  "update:store",
],
  setup(__props, { emit }) {

const props = __props;

let timeoutId;



const isFocus = ref(false);



const updateStore = () => {
  emit("update:valueTeamPage", true);
};

const value: any = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (props.delayChangeInput > 0) updateWithDelayTimeOut(newValue);
    else {
      emit("update:modelValue", newValue);
      emit("update:store");
    }
  },
});

const updateWithDelayTimeOut = (value) => {
  timeoutId && clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    emit("update:modelValue", value);
    emit("update:store");
  }, 650);
};

const handleBlur = (value) => {
  isFocus.value = false;
  props.validation?.$validate();
  emit("handleBlur", { value: value, index: props.index });
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BFormTextarea = _resolveComponent("BFormTextarea")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_row, { class: "tw-mt-[20px] align-items-start" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass(['tw-flex', 'tw-items-center']),
          sm: __props.colTitle
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", {
              class: _normalizeClass([
            'tw-mb-0 tw-text-[13px] tw-text-[#231F20] tw-leading-[145%] tw-font-medium tw-font-Poppins',
            __props.classTitle,
          ])
            }, _toDisplayString(__props.title), 3),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " *"))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "rightHeader")
          ]),
          _: 3
        }, 8, ["sm"]),
        _createVNode(_component_b_col, { sm: __props.colInput }, {
          default: _withCtx(() => [
            (__props.type === _unref(INPUT_TYPE).Date)
              ? (_openBlock(), _createBlock(DatePickInput, {
                  key: 0,
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
                  "data-cy-id": __props.dataCyId,
                  disabled: __props.disabled,
                  placeholder: __props.placeholder,
                  "is-auto-focus": __props.isAutoFocus,
                  "class-name": `${
            __props.validation?.$errors[0] || __props.validState !== null
              ? 'is-invalid-input'
              : ''
          } ${__props.inputClass}`,
                  "valid-state": __props.validState
                }, null, 8, ["modelValue", "data-cy-id", "disabled", "placeholder", "is-auto-focus", "class-name", "valid-state"]))
              : (__props.type !== _unref(INPUT_TYPE).TextArea)
                ? (_openBlock(), _createBlock(_component_BFormInput, {
                    key: 1,
                    modelValue: value.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
                    "data-cy": __props.dataCyId,
                    type: __props.type,
                    disabled: __props.disabled,
                    placeholder: __props.placeholder,
                    class: _normalizeClass([
            'date-picker-input autoFocus',
            __props.validation?.$error &&
            (!isFocus.value ||
              (isFocus.value && __props.validation?.$errors?.[0]?.$validator === 'required'))
              ? 'is-invalid-input'
              : '',
          ]),
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (handleBlur(value.value))),
                    onFocus: _cache[3] || (_cache[3] = ($event: any) => (isFocus.value = true)),
                    onInput: updateStore
                  }, null, 8, ["modelValue", "data-cy", "type", "disabled", "placeholder", "class"]))
                : (__props.type === _unref(INPUT_TYPE).TextArea)
                  ? (_openBlock(), _createBlock(_component_BFormTextarea, {
                      key: 2,
                      id: "note",
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((value).value = $event)),
                      "data-cy": __props.dataCyId,
                      disabled: __props.disabled,
                      class: _normalizeClass(`autoFocus tw-h-[90px] tw-flex tw-w-full tw-items-start tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[13px] tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#eff0f180] ${
            __props.validation?.$errors[0] ? 'is-invalid-input' : ''
          }`),
                      placeholder: __props.placeholder,
                      "no-resize": true
                    }, null, 8, ["modelValue", "data-cy", "disabled", "class", "placeholder"]))
                  : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "rightInput")
          ]),
          _: 3
        }, 8, ["sm"])
      ]),
      _: 3
    }),
    _createVNode(_component_b_row, { class: "align-items-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass(`col-sm-6 tw-pr-0 tw-pl-0`)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "feedback", {}, () => [
              (
              !isFocus.value ||
              (isFocus.value &&
                __props.validation?.$errors?.[0]?.$validator === 'required') ||
              __props.validState !== null
            )
                ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                    key: 0,
                    class: _normalizeClass(`${
              __props.validation?.$error || __props.validState !== null ? 'is-invalid' : ''
            } ${__props.validationClass}`)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VRuntimeTemplate), {
                        template: __props.validation?.$errors?.[0]?.$message || __props.validMessage
                      }, null, 8, ["template"])
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    _createVNode(_component_b_row, { class: "row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-container tw-pr-0 tw-pl-0 tw-flex tw-items-center')
        }),
        _createVNode(_component_b_col, {
          class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}
}

})